const translations = { required: 'Required field', invalidEmail: 'Invalid email' }

export default translations
